module.exports = __webpack_public_path__ + "static/media/S17_W.20665f02.png";